import { UseQueryResult } from '@tanstack/react-query'
import {
  GetServiceConfigurationRequestParam,
  GetServiceConfigurationResBody,
  getServiceConfiguration,
} from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'

import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface Props {
  enabled?: boolean
  useErrorBoundary?: boolean
}

type Params = GetServiceConfigurationRequestParam

function useGetServiceConfiguration<T extends Record<string, any>>(
  params: Params,
  props?: Props
): UseQueryResult<GetServiceConfigurationResBody<T>, AxiosError> {
  return useQueryWrapper<GetServiceConfigurationResBody<T>, AxiosError>(
    KEYS.SERVICE_CONFIG(params.key ?? params.keyGroup),
    async () => {
      const { data } = await getServiceConfiguration<T>(params)
      return data
    },
    {
      enabled: props?.enabled ?? true,
      useErrorBoundary: props?.useErrorBoundary ?? true,
    }
  )
}

export { useGetServiceConfiguration }
